export const terms = [
  new Array(1).fill(' '),
  new Array(3).fill(' '),
  new Array(1).fill(' '),
];

export const settings = new Array(5).fill(' ');
